<ion-list>
  <ion-item (click)="toMonAbonnement()" lines="none" button>Mon forfait</ion-item>
  <ion-item (click)="toContact()" lines="none" button>Contact</ion-item>
  <ion-item (click)="toAide()" lines="none" button>Aide</ion-item>
  <ion-item (click)="presentResetPassword()" lines="none" button>Modifier mon mot de passe</ion-item>
  <ion-item (click)="disconnect()" lines="none" button>Se déconnecter</ion-item>
  <ion-item (click)="presentSuppressionModal()" lines="none" button>Supprimer mon profil</ion-item>
</ion-list>
